import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { untilDestroyed, UrlParamsService } from '@app/core';
import { User } from '@app/models';
import { UserService, AuthenticationService } from '@app/services';

@Component({
  selector: 'app-mobile-header-secondary',
  templateUrl: './mobile-header-secondary.component.html',
  styleUrls: ['./mobile-header-secondary.component.scss'],
  standalone: false
})
export class MobileHeaderSecondaryComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() menuID: string;
  @Input() disablePageChange: boolean;
  @Input() standalone: boolean;
  @Output() goBack = new EventEmitter();
  currentUser: User;
  hasNewMenu: boolean;

  constructor(public urlParamsService: UrlParamsService, private location: Location, private router: Router, private authenticationService: AuthenticationService, private userService: UserService) {
    this.hasNewMenu = false;
  }

  ngOnInit() {
    this.hasNewMenu = this.menuID !== undefined;

    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => (this.currentUser = user)
      });
  }

  ngOnDestroy() {}

  goBackClick() {
    this.goBack.emit();
    if (!this.disablePageChange) {
      this.location.back();
    }
  }

  logout() {
    this.authenticationService.logout().subscribe({
      next: () => this.router.navigate(['/entrar'], { replaceUrl: true })
    });
  }

  showMobileNavigation() {
    return this.urlParamsService.params.mobileNavigation && !this.standalone;
  }
}
